"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureSubscriptionManagement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _api = require("../../api");
var _innerPopupReducer = require("../../redux/innerPopupReducer");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _retentionActionsSlice = require("../../redux/retentionActionsSlice");
var _popupSlice = require("../../redux/popupSlice");
var _planHelper = require("../../util/planHelper");
var _Button = _interopRequireDefault(require("../Button"));
var _CouponInput = _interopRequireDefault(require("../CouponInput"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _appConfigHelper = require("../../util/appConfigHelper");
var _trackMixpanelEvent = _interopRequireDefault(require("../../util/trackMixpanelEvent"));
var _SubscriptionManagementStyled = require("./SubscriptionManagementStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubscriptionManagement = _ref => {
  let {
    subscription,
    showMessageBox
  } = _ref;
  const {
    pauseOffersIDs
  } = (0, _reactRedux.useSelector)(store => store.offers);
  const {
    data: switchSettings
  } = (0, _reactRedux.useSelector)(store => store.plan.switchSettings);
  const isRetentionActionsLoading = (0, _reactRedux.useSelector)(_retentionActionsSlice.selectRetentionActionsIsLoading);
  const [isOptionsVisible, setIsOptionsVisible] = (0, _react.useState)(false);
  const [isCouponInputOpened, setIsCouponInputOpened] = (0, _react.useState)(false);
  const [isError, setIsError] = (0, _react.useState)(false);
  const [errorMsg, setErrorMsg] = (0, _react.useState)('');
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [couponValue, setCouponValue] = (0, _react.useState)('');
  const userId = (0, _appConfigHelper.getData)('CLEENG_CUSTOMER_ID');
  const publisherId = (0, _appConfigHelper.getData)('CLEENG_PUBLISHER_ID');
  const {
    offerId,
    offerTitle,
    nextPaymentPrice: offerPrice,
    nextPaymentCurrency: offerCurrency,
    status,
    subscriptionId
  } = subscription;
  const isPaused = pauseOffersIDs.includes(offerId);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const submitCoupon = targetSubscriptionId => {
    if (couponValue) {
      setIsLoading(true);
      (0, _api.applyCoupon)(targetSubscriptionId, couponValue).then(resp => {
        switch (resp.status) {
          case 200:
            setIsCouponInputOpened(false);
            setIsLoading(false);
            dispatch((0, _planDetailsSlice.updateList)());
            showMessageBox('success', t('subscription-management.coupon-redeemed', 'Your Coupon has been successfully reedemed.'), targetSubscriptionId);
            window.dispatchEvent(new CustomEvent('MSSDK:redeem-coupon-success', {
              detail: {
                coupon: couponValue,
                source: 'myaccount'
              }
            }));
            break;
          case 422:
            if (resp.errors.some(e => e.includes('not found') || e.includes('cannot be applied on this offer') || e.includes('cannot be applied on existing subscription') || e.includes('reserved'))) {
              setErrorMsg(t('subscription-management.invalid-coupon', 'Invalid coupon code.'));
            }
            if (resp.errors.some(e => e.includes('already applied'))) {
              setErrorMsg(t('subscription-management.coupon-already-applied', 'Coupon already applied'));
            }
            if (resp.errors.some(e => e.includes('already used'))) {
              setErrorMsg(t('subscription-management.coupon-already-used', 'Coupon already used'));
            }
            setIsError(true);
            setIsLoading(false);
            window.dispatchEvent(new CustomEvent('MSSDK:redeem-coupon-failed', {
              detail: {
                coupon: couponValue,
                source: 'myaccount'
              }
            }));
            break;
          default:
            setErrorMsg(t('subscription-management.invalid-coupon', 'Invalid coupon code.'));
            setIsError(true);
            setIsLoading(false);
            break;
        }
      }).catch(() => {
        window.dispatchEvent(new CustomEvent('MSSDK:redeem-coupon-failed', {
          detail: {
            coupon: couponValue,
            source: 'myaccount'
          }
        }));
        setErrorMsg(t('oops-something-went-wrong', 'Oops! Something went wrong.'));
        setIsError(true);
        setIsLoading(false);
      });
    } else {
      setErrorMsg(t('subscription-management.enter-coupon', 'Please enter coupon code.'));
      setIsError(true);
    }
  };
  const toggle = e => {
    e.stopPropagation();
    setIsOptionsVisible(isVisible => !isVisible);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SubscriptionManagementStyled.SubscriptionManagementStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.ManageButtonWrapStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "simple",
        width: "unset",
        onClickFn: e => toggle(e),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.ButtonTextStyled, {
          isExpanded: isOptionsVisible,
          children: t('subscription-management.manage-button', 'Manage')
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.SubscriptionActionsStyled, {
      isOpened: isOptionsVisible,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SubscriptionManagementStyled.WrapperStyled, {
        children: [status === 'active' && !isCouponInputOpened && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.SimpleButtonStyled, {
          theme: "simple",
          onClickFn: event => {
            event.stopPropagation();
            dispatch((0, _retentionActionsSlice.fetchRetentionActions)(subscription.offerId)).then(() => {
              dispatch((0, _planDetailsSlice.setOfferToSwitch)(subscription));
              dispatch((0, _popupSlice.showPopup)({
                type: _innerPopupReducer.POPUP_TYPES.updateSubscription,
                data: {
                  action: 'unsubscribe',
                  offerData: {
                    ...subscription
                  }
                }
              }));
            });
            window.dispatchEvent(new CustomEvent('MSSDK:unsubscribe-button-clicked', {
              detail: {
                offerId
              }
            }));
            (0, _trackMixpanelEvent.default)('Unsubscribe Attempt', {
              distinct_id: userId,
              publisherId,
              offerId,
              offerTitle,
              offerPrice,
              offerCurrency
            });
          },
          children: isRetentionActionsLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
            buttonLoader: true,
            color: "#515364"
          }) : t('subscription-management.unsubscribe-button', 'Unsubscribe')
        }), status === 'cancelled' && !isCouponInputOpened && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.FullWidthButtonStyled, {
          theme: "simple",
          onClickFn: event => {
            event.stopPropagation();
            dispatch((0, _popupSlice.showPopup)({
              type: _innerPopupReducer.POPUP_TYPES.updateSubscription,
              data: {
                action: 'resubscribe',
                offerData: {
                  ...subscription,
                  price: "".concat(offerPrice).concat(_planHelper.currencyFormat[offerCurrency])
                }
              }
            }));
            window.dispatchEvent(new CustomEvent('MSSDK:resume-button-clicked', {
              detail: {
                offerId
              }
            }));
          },
          children: t('subscription-management.resume-button', 'Resume')
        }), status !== 'cancelled' && !isPaused && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.CouponWrapStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponInput.default, {
            couponDetails: {
              showMessage: isError,
              message: errorMsg
            },
            fullWidth: true,
            value: couponValue,
            couponLoading: isLoading,
            onSubmit: () => submitCoupon(subscriptionId),
            onChange: e => setCouponValue(e),
            onClose: () => setIsCouponInputOpened(val => !val),
            onInputToggle: () => setIsCouponInputOpened(val => !val),
            source: "myaccount"
          })
        }), isPaused && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionManagementStyled.SimpleButtonStyled, {
          theme: "primary",
          onClickFn: event => {
            event.stopPropagation();
            dispatch((0, _popupSlice.showPopup)({
              type: _innerPopupReducer.POPUP_TYPES.resumeSubscription,
              data: {
                offerData: {
                  ...switchSettings[subscription === null || subscription === void 0 ? void 0 : subscription.offerId].available[0]
                }
              }
            }));
          },
          children: t('subscription-management.resume-subscription-button', 'Resume subscription')
        })]
      })
    })]
  });
};
exports.PureSubscriptionManagement = SubscriptionManagement;
SubscriptionManagement.propTypes = {
  subscription: _propTypes.default.objectOf(_propTypes.default.any),
  showMessageBox: _propTypes.default.func
};
SubscriptionManagement.defaultProps = {
  subscription: {},
  showMessageBox: () => null
};
var _default = exports.default = SubscriptionManagement;